import React, { FC, useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useAppDispatch } from 'app/store';
import { createNewAwardThunk, getNewAwardThunk, updateAwardThunk } from './thunk';
import { IPostAdminAward } from './types';

interface FormValues {
  name: string;
  description: string;
  estimation: number;
  image_main: FileList;
}

export const CreatedPrize: FC<{
  index: number;
  updateItemPrizeIdAward: (itemIndex: number, evValue: string) => void;
  prizeId: number | null;
}> = ({ index, updateItemPrizeIdAward, prizeId }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<FormValues>();
  const [saved, setSaved] = useState(false);
  const [imageString, setImageString] = useState<string | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  const watchedFields = watch();
  useEffect(() => {
    setTimeout(() => {
      if (saved) {
        setSaved(false);
      }
    }, 2000);
  }, [watchedFields]);

  useEffect(() => {
    if (prizeId && prizeId !== 0) {
      dispatch(getNewAwardThunk(prizeId)).then((ans) => {
        const awardsData: any = ans.payload;
        reset({
          name: awardsData.name,
          description: awardsData.description,
          estimation: awardsData.estimation,
        });
        setImageString(awardsData.image_main);
      });
    }
  }, [prizeId, dispatch, reset]);

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    const imageFile = data.image_main && data.image_main[0];
    const formPayload: IPostAdminAward.Request = {
      name: data.name,
      description: data.description,
      estimation: data.estimation,
      image_main: imageFile,
    };

    dispatch(!prizeId ? createNewAwardThunk(formPayload) : updateAwardThunk({ ...formPayload, id: prizeId })).then(
      (ans) => {
        if (!ans.payload) return;
        const awardsData: any = ans.payload;
        reset({
          name: awardsData.name,
          description: awardsData.description,
          estimation: awardsData.estimation,
        });
        setImageString(awardsData.image_main);
        updateItemPrizeIdAward(index, awardsData.id);
        setSaved(true);
      },
    );
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ marginBottom: '10px' }}
      >
        <TextField
          style={{ marginBottom: '10px' }}
          label="Название"
          {...register('name', { required: 'Название обязательно' })}
          error={!!errors.name}
          helperText={errors.name?.message}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          style={{ marginBottom: '10px' }}
          label="Описание"
          {...register('description')}
          error={!!errors.description}
          helperText={errors.description?.message}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          style={{ marginBottom: '10px' }}
          label="Номинальная стоимость"
          type="number"
          {...register('estimation', {
            required: 'Номинальная стоимость обязательна',
            min: { value: 0, message: 'Номинальная стоимость не может быть меньше 0' },
          })}
          error={!!errors.estimation}
          helperText={errors.estimation?.message}
          fullWidth
          InputProps={{ inputProps: { min: 0 } }}
          InputLabelProps={{ shrink: true }}
        />
        {(imageString || imagePreview) && (
          <div style={{ display: 'flex', position: 'relative', overflow: 'hidden' }}>
            <img
              style={{ width: '33%', height: '100%' }}
              src={imagePreview || (imageString as string)}
              alt=""
            />
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          {...register('image_main', {
            required: 'Изображение обязательно',
            onChange: (e) => {
              if (e.target.files && e.target.files[0]) {
                setImagePreview(URL.createObjectURL(e.target.files[0]));
              }
            },
          })}
        />
        {errors.image_main && <p style={{ color: 'red' }}>{errors.image_main.message}</p>}
        <Button
          disabled={saved}
          style={{ marginBottom: '10px', marginTop: '5px' }}
          type="submit"
          variant="contained"
          color="primary"
        >
          {saved ? 'Сохранено' : 'Сохранить'}
        </Button>
      </form>
    </div>
  );
};
